import {
  AvgTimeToDeliverByServiceLevelResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgTimeToDeliverByServiceLevel = {
  name: "getAvgTimeToDeliverByServiceLevel" as const,
  input: OMSMetricsRequestSchema,
  output: AvgTimeToDeliverByServiceLevelResponseSchema,
};
